var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-page',{attrs:{"page":"Dashboards","breadcrumb":_vm.breadcrumb}},[_c('v-container',{attrs:{"ma-0":"","px-4":"","pt-3":"","pb-0":""}},[_c('bar-chart-container',{attrs:{"DBID":_vm.DBID,"isMounted":_vm.isMounted}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }